import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const LazyImage = ({ alt, src, className = "" }) => (
    <span className={`${className}`}>
        <LazyLoadImage
            height="100%"
            width="100%"
            className={`${className}`}
            alt={alt}
            src={src}
            effect="blur"
        />
    </span>
);

export default LazyImage;
